<template>
  <div class="modal-wrap">
    <transition name="fade">
      <div class="jl-modal-wrap" v-if="showModal" @click="cancel">
        <div class="jl-modal-box" @click.stop="fn">
          <div class="main-info-form">
            <p class="form-title">{{isModify?'修改手机号码':'绑定手机号码'}}</p>
            <div class="form-ground">
              <label class="form-label">手机号码</label>
              <div class="form-el-wrap">
                <input
                  type="text"
                  v-model="form.phone"
                  :class="[rules.phone.isError?'form-input error':'form-input']"
                  placeholder="请输入手机号"
                  @blur="checkPhone('phone')"
                />
                <div v-if="rules.phone.isError" class="form-error">{{rules.phone.errorText}}</div>
              </div>
            </div>
            <div class="form-ground code">
              <label class="form-label">验证码</label>
              <div class="form-el-wrap">
                <div style="position: relative;">
                  <input
                    type="text"
                    v-model="form.code"
                    :class="[rules.code.isError?'form-input error':'form-input']"
                    placeholder="请输入验证码"
                    @blur="checkCode('code')"
                  />
                  <div
                    :class="[boolSendCode?'form-send-code':'form-send-code disabled'] "
                    @click="sendCode"
                  >{{sendBtnText}}</div>
                </div>
                <div v-if="rules.code.isError" class="form-error">{{rules.code.errorText}}</div>
              </div>
            </div>
            <div class="form-ground">
              <button class="btn" @click="cancel">取消</button>
              <button class="btn active" @click="submit">
                保存
                <span class="jl-loading" v-if="isLoading">
                  <i class="jl-icon-loading"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="shadow-model" v-if="showModal"></div>
  </div>
</template>

<script>
import { getVerifyCode, setPhone } from "@/api/user.js";
export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    phone: {
      type: String,
      default: ""
    },
    userId: {
      type: String,
      default: ""
    },
    isModify: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    phone(n, o) {
      if (n) {
        this.form.phone = n;
      }
    }
  },
  data() {
    const _phone = this.phone;
    return {
      form: {
        phone: _phone,
        code: ""
      },
      isShowModalBox: false,
      isLoading: false,
      rules: {
        phone: {
          isError: false,
          errorText: "",
          text1: "请输入手机号",
          text2: "手机号码格式不正确"
        },
        code: {
          isError: false,
          errorText: "",
          text1: "请输入验证码",
          text2: "验证码不正确"
        }
      },
      sendBtnText: "获取验证码",
      boolSendCode: true,
      timer: null
    };
  },
  methods: {
    fn() {},
    submit() {
      let boolPhone = this.checkPhone("phone"),
        boolCode = this.checkCode("code");
      if (boolPhone && boolCode) {
        this.isLoading = true;
        setPhone(this, () => {
          this.isLoading = false;
          // this.form.code = "";
          // clearTimeout(this.timer);
          // this.sendBtnText = "获取验证码";
          // this.boolSendCode = true;
        });
      }
    },
    checkPhone(val) {
      let regPhone = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!this.form[val]) {
        this.rules[val].isError = true;
        this.rules[val].errorText = this.rules[val].text1;
        return false;
      } else if (!regPhone.test(this.form[val])) {
        this.rules[val].isError = true;
        this.rules[val].errorText = this.rules[val].text2;
        return false;
      } else {
        this.rules[val].isError = false;
        this.rules[val].errorText = "";
        return true;
      }
    },
    checkCode(val) {
      if (!this.form[val]) {
        this.rules[val].isError = true;
        this.rules[val].errorText = this.rules[val].text1;
        return false;
      } else {
        this.rules[val].isError = false;
        this.rules[val].errorText = "";
        return true;
      }
    },
    setSendTime(val) {
      this.sendBtnText = "重新获取" + "(" + val + "s)";
      this.timer = setTimeout(() => {
        if (val === 0) {
          this.sendBtnText = "获取验证码";
          this.boolSendCode = true;
        } else {
          this.setSendTime(--val);
        }
      }, 1000);
    },
    sendCode() {
      if (this.boolSendCode) {
        let boolPhone = this.checkPhone("phone");
        if (boolPhone) {
          getVerifyCode(this, bool => {
            if (bool) {
              this.boolSendCode = false;
              this.setSendTime(60);
            }
          });
        }
      }
    },
    //取消
    cancel() {
      this.isShowModalBox = false;
      this.$emit("cancel");
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}
.fade-enter, 
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateY(20px);
  opacity: 0;
}
.form-el-wrap {
  position: relative;
}
.modal-wrap {
  .shadow-model {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 499;
    background: rgba($color: #000, $alpha: 0.7);
  }
}

.jl-modal-wrap {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 500;
  text-align: center;
  &:after {
    content: "";
    display: inline-block;
    height: 100%;
    width: 0;
    vertical-align: middle;
  }

  .jl-modal-box {
    position: relative;
    z-index: 10;
    display: inline-block;
    width: 500px;
    padding: 20px;
    vertical-align: middle;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    font-size: 18px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    text-align: left;
    overflow: hidden;
    backface-visibility: hidden;
  }
}
.main-info-form {
  .form-title {
    font-size: 20px;
    text-align: center;
    color: #333;
    margin-bottom: 15px;
  }
  .form-ground {
    position: relative;
    padding-left: 84px;
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    .form-label {
      position: absolute;
      left: 0;
      top: 0;
      font-size: 14px;
      color: #333;
      line-height: 42px;
      &::before {
        content: "*";
        color: #e81727;
        margin-right: 4px;
      }
    }
    .form-input {
      display: block;
      width: 100%;
      height: 42px;
      background: transparent;
      border: 1px solid #ccc;
      padding: 0 13px;
      &.error {
        border-color: #e81727;
      }
    }
    .btn {
      width: 100px;
      height: 42px;
      line-height: 42px;
      text-align: center;
      font-size: 16px;
      color: #e81727;
      border: 1px solid #e81727;
      background: transparent;
      cursor: pointer;
      outline: none;
      margin-right: 15px;
      &.active {
        color: #fff;
        background: #e81727;
        border-color: #e81727;
      }
    }
    .form-error {
      position: absolute;
      top: 100%;
      left: 0;
      font-size: 12px;
      color: #e81727;
      line-height: 1;
      margin-top: 2px;
      padding-left: 20px;
      background: url("../assets/img/zkj-form-tips.png") no-repeat left center;
      background-size: 12px;
    }
    &.code {
      .form-input {
        padding-right: 120px;
      }
      .form-send-code {
        position: absolute;
        right: 0;
        top: 0;
        height: 42px;
        line-height: 42px;
        font-size: 14px;
        color: #328aff;
        padding: 0 26px;
        cursor: pointer;
        z-index: 20;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 1px;
          height: 25px;
          background: #e0e0e0;
        }
        &.disabled {
          color: #ccc;
          cursor: not-allowed;
        }
      }
    }
  }
}

::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #ccc;
}
:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #ccc;
}
::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #ccc;
}
:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #ccc;
}

.jl-loading {
  display: inline-block;
  animation: rotating 2s linear infinite;
  i {
    font-size: 18px;
  }
}
@keyframes rotating {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
